<template>
    <v-dialog v-model="isDialogShown" :persistent="persistent" :max-width="width">
        <v-card flat style="position:relative;">
            <v-btn v-if="showClose" class="close-btn" @click="secondButtonFunction" outlined icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-title class="page-title pa-4" style="color: white;"
                :style="{ 'background-color': titleBackgroudColor, 'color': titleFontColor, }">
                {{ title }}
            </v-card-title>
            <v-card-text class="text-center">
                <div class="pt-7" style="font-size: 18px;" :style="contentStyle" v-html="content"></div>
            </v-card-text>
            <v-card-actions class="pa-0 pb-5">
                <v-row class="ma-0" justify="center" align="center">
                    <v-col class="pa-0" :cols="cellphone ? 12 : 'auto'">
                        <BrebBtn backgroundColor="green" @click="buttonFunction">
                            {{ buttonContent }}
                        </BrebBtn>
                    </v-col>
                    <v-col class="pa-0" :cols="cellphone ? 12 : 'auto'">
                        <BrebBtn v-if="secondButtonFunction !== null" @click="secondButtonFunction"
                            backgroundColor="yellow" color="black">
                            {{ secondButtonContent }}
                        </BrebBtn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import BrebBtn from "@/components/accessory/BrebBtn.vue"

export default {
    name: "BrebDialog",
    components: {
        BrebBtn,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: "Notice"
        },
        titleBackgroudColor: {
            type: String,
            required: false,
            default: "orange"
        },
        titleFontColor: {
            type: String,
            required: false,
            default: "white"
        },
        content: {
            type: String,
            required: true,
        },
        buttonContent: {
            type: String,
            required: false,
            default: "Close"
        },
        buttonFunction: {
            type: Function,
            required: true,
        },
        secondButtonContent: {
            type: String,
            required: false,
            default: "Cancel"
        },
        secondButtonFunction: {
            type: Function,
            required: false,
            default: null,
        },
        isDialogShown: {
            type: Boolean,
            required: true,
            default: () => false,
        },
        width: {
            type: Number,
            required: false,
            default: () => 600,
        },
        persistent: {
            type: Boolean,
            required: false,
            default: () => true,
        },
        contentStyle: {
            type: Object,
            required: false,
        },
        showClose: {
            type: Boolean,
            default: () => false,
        }
    },
    data() {
        return {

        }
    },
    computed: {
        cellphone() {
            return this.$vuetify.breakpoint.xs
        },
        mobile() {
            return this.$vuetify.breakpoint.mobile
        },
    },
    watch: {

    },
    methods: {

    },
    mounted() {

    }
}
</script>
<style scoped></style>

<style lang="scss">
@import '../../../node_modules/vuetify/src/styles/settings/variables';
@import "../../globals";

@media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {}

@media only screen and (min-width: map-get($grid-breakpoints, 'sm')) {}
</style>